<script lang="ts">
    export let value: any;
</script>

{typeof value === 'object' ? JSON.stringify(value) : value}